import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';

export interface TroughDispatcherProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel>;
}

const dispatchKey = 'trough';

class TroughDispatcherContainer extends React.Component<TroughDispatcherProps> {

  componentDidMount() {
    this.dispatchTrough();
  }

  componentDidUpdate(prevProps: TroughDispatcherProps) {
    const { configuration } = prevProps;
    const prevId = configuration && configuration.result && configuration.result.troughId;
    if (prevId !== this.troughId) {
      this.dispatchTrough();
    }
  }

  public render() {
    return null;
  }

  private get troughId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.troughId;
  }

  private dispatchTrough() {
    if (this.troughId) {
      this.props.dispatch(requestAPIActions.load(
        dispatchKey, {
          url: `/Troughs/${this.troughId}`,
          queryParams: {
            include: 'images',
            order: 'name'
          },
        },
        true
      ));
    }
  }
}

export const TroughDispatcher = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(TroughDispatcherContainer);
